// external Add Ons Types
export const RECEIVE_EXTERNAL_ADDONS = 'RECEIVE_EXTERNAL_ADDONS';
export const RECEIVE_EXTERNAL_ADDONS_BULK = 'RECEIVE_EXTERNAL_ADDONS_BULK';
export const UPDATE_ZIPCDOE = 'UPDATE_ZIPCDOE';
export const UPDATE_DELIVERY_DATE = 'UPDATE_DELIVERY_DATE';
export const SET_ERROR = 'SET_ERROR';
export const SET_ADD_ON_SELECTION = 'SET_ADD_ON_SELECTION';
export const SET_ADD_ON_IN_FLIGHT = 'SET_ADD_ON_IN_FLIGHT';
export const RECEIVE_CART_RESULTS = 'RECEIVE_CART_RESULTS';
export const RESET_EXTERNAL_ADDONS = 'RESET_EXTERNAL_ADDONS';
